// src/modules/app-views/services/pages/Document/tabs/AiInfoTab/FiscalDataSection.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Descriptions, Collapse, Typography, theme } from 'antd';
import { AuditOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { DEFAULT_OPEN_KEYS } from './index';

const { Text } = Typography;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const FiscalDataSection = ({ data, aiResponse, isMobile }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { token } = theme.useToken();
  const fd = aiResponse?.fiscalData;

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  const hasData = fd && (fd.cnae || fd.lc116Code || fd.issTaxRate !== undefined);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!hasData) return null;

  return (
    <Collapse
      className="collapsed-content-fit"
      defaultActiveKey={DEFAULT_OPEN_KEYS.includes('fiscal-data') ? ['fiscal-data'] : []}
      style={{ marginBottom: 16 }}
      items={[
        {
          key: 'fiscal-data',
          label: (
            <Flex align="center" gap={8}>
              <AuditOutlined style={{ color: token.colorPrimary }} />
              <span style={{ fontWeight: 600 }}>{translateX('fiscal_data')}</span>
            </Flex>
          ),
          showArrow: false,
          children: (
            <Descriptions
              bordered
              size="small"
              column={1}
              layout={isMobile ? 'vertical' : 'horizontal'}
              styles={{ label: { fontWeight: 500 } }}
            >
              {fd.cnae && (
                <Descriptions.Item label="CNAE">
                  {fd.cnae}
                  {fd.cnaeDescription && (
                    <Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
                      {fd.cnaeDescription}
                    </Text>
                  )}
                </Descriptions.Item>
              )}
              {fd.lc116Code && (
                <Descriptions.Item label="LC 116">
                  {fd.lc116Code}
                  {fd.lc116Description && (
                    <Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
                      {fd.lc116Description}
                    </Text>
                  )}
                </Descriptions.Item>
              )}
              {fd.issTaxRate !== undefined && (
                <Descriptions.Item label="ISS">
                  {fd.issTaxRate}%
                </Descriptions.Item>
              )}
            </Descriptions>
          ),
        },
      ]}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default FiscalDataSection;
